import * as types from '../types'

export default {
    state: {
      userId: '',
      //userId: null,
      token: null,
      footerShow:true,
      tabname:'',
      code:''
    },
    mutations: {
        [types.LOGIN]: (state, data) => {
          sessionStorage.token = data;
          state.token = data;
        },
        [types.LOGOUT]: (state) => {
          sessionStorage.removeItem('token');
          sessionStorage.removeItem('userId');
          state.token = null;
          state.userId = null;
        },
        [types.TITLE]: (state, data) => {
            state.title = data;
        },
        [types.USER]: (state, data) => {
          sessionStorage.userId = data;
          state.userId = data;
        },
        [types.FOOTERSHOW]: (state, data) => {
          state.footerShow = data;
        },
        [types.TABNAME]: (state, data) => {
          state.tabname = data;
        }
    },
	actions:{

	},
	getter:{

	}

}



// WEBPACK FOOTER //
// ./src/store/common/store.js